export default __webpack_public_path__ + "static/media/no-image.b8b6bd8a.svg";